export default "__VITE_ASSET__rVH5PIJd__"